import styles from './SpinnerWrapper.module.scss'
import { RingLoader } from 'react-spinners'
import { ReactElement } from 'react'

interface SpinnerProps {
  loaded: boolean
  isMobile: boolean
  children: ReactElement
}

export const SpinnerWrapper = ({ loaded, isMobile, children }: SpinnerProps): ReactElement => {
  if (!loaded) {
    return (
      <div className={styles.spinnerContainer}>
        <RingLoader size={isMobile ? '10rem' : '15rem'} color='#FBFBFB' />
      </div>
    )
  }

  return children
}
